const BASE = process.env.VUE_APP_ENV === 'preview' ? 'api/gp-author-staging' : 'api/gp-author'
const urls = {
  /*
  * id
  * */
  liveUserRank: 'get /api/v1/app/rank/get/room/gift',
}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${BASE}${arr[1]}`
}
export default URLS
